import * as React from 'react';
import {Helmet} from 'react-helmet-async';

import * as styles from './stickyNav.module.scss';

interface StickyNavProps {
  children: React.ReactNode;
}

interface StickyNavState {
  isSticky: boolean;
  rafId: number | null;
  scrollY: number;
}

class StickyNav extends React.Component<StickyNavProps, StickyNavState> {
  stickyEl: HTMLDivElement;

  constructor(props: StickyNavProps) {
    super(props);

    this.state = {
      isSticky: false,
      rafId: null,
      scrollY: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // Wait for next animation frame.
    if (this.state.rafId) {
      return;
    }

    const rafId = window.requestAnimationFrame(() => {
      const scrollY = window.scrollY;

      let isSticky = false;
      if (this.stickyEl) {
        isSticky =
          this.state.scrollY > scrollY
            ? scrollY > this.stickyEl.clientHeight // Stick when passing nav bar when scrolling up
            : scrollY > this.stickyEl.clientHeight * 1.5; // Stick when passing nav height + buffer when scrolling down
      }

      this.setState({isSticky, rafId: null, scrollY});
    });

    this.setState({rafId});
  };

  render() {
    const {children} = this.props;
    const {isSticky} = this.state;

    return (
      <div
        className={styles.wrapper}
        ref={stickyEl => (this.stickyEl = stickyEl)}>
        <Helmet>
          <body className={isSticky ? 'isSticky' : ''} />
        </Helmet>
        <div className={styles.content}>{children}</div>
      </div>
    );
  }
}

export default StickyNav;
